import email from './email';
import facebook from './facebook';
import linkedin from './linkedin';
import twitter from './twitter';

const types = {
  email,
  facebook,
  linkedin,
  twitter,
};

export default function (type, ...args) {
  return types[type](...args);
}



// WEBPACK FOOTER //
// ./app/services/share/index.js